import {FIELD_VALUE_VALIDATORS} from '@utils/fieldValueValidators';

// Mirrors Java's Character.isWhitespace (used by Spring's StringUtils.hasText): no-break spaces count as text.
// eslint-disable-next-line no-control-regex
const JAVA_NON_TEXT_PATTERN = /^[\t\n\v\f\r\x1C-\x1F \u1680\u2000-\u2006\u2008-\u200A\u2028\u2029\u205F\u3000]*$/;

function getHasText(value: string | null | undefined): boolean {
    return typeof value === 'string' && !JAVA_NON_TEXT_PATTERN.test(value);
}

/**
 * Returns the message key for a value that fails the field's validation type, or null when empty, valid or unchecked on the client.
 * @param validationType - field.validation.type from field-service
 * @param value - raw field value
 */
export function getFieldValueErrorKey(validationType: string | null | undefined, value: string | null | undefined): string | null {
    const validator = validationType ? FIELD_VALUE_VALIDATORS[validationType] : undefined;
    return validator && getHasText(value) ? validator(value) : null;
}
